export default e => {
    app.logout();

    window.index.commit('logout');
}
